import { Component, inject, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AppModule } from '../../../app-module';

@Component({
  selector: 'oaj-confirmation-dialog-itx',
  templateUrl: './confirm-dialog.component.html',
   styleUrls: ['./confirm-dialog.component.css'],
   imports: [AppModule],
})
export class ConfirmationDialogComponent {

  @Input()
  title!: string;
  @Input()
  message!: string;
  @Input()
  btnOkText!: string;
  @Input() btnCancelText?: string;
  private activeModal: NgbActiveModal = inject(NgbActiveModal);


  public decline() {
    this.activeModal.close(false);
  }

  public accept() {
    this.activeModal.close(true);
  }

  public dismiss() {
    this.activeModal.dismiss();
  }

}
